import { render, staticRenderFns } from "./OaScheduleList.vue?vue&type=template&id=63fc6543&scoped=true"
import script from "./OaScheduleList.vue?vue&type=script&lang=js"
export * from "./OaScheduleList.vue?vue&type=script&lang=js"
import style0 from "./OaScheduleList.vue?vue&type=style&index=0&id=63fc6543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc6543",
  null
  
)

export default component.exports